import { filter } from "@suse-o11y/filter";
import { isPresent } from "@suse-o11y/is-present";
import { Template } from "@suse-o11y/template";
import { z } from "zod";

export const dashboardMetricsMatchers = z
	.array(
		z
			.string()
			.trim()
			.min(1, "Matcher cannot be empty")
			.transform((trimmed) => Template<null>(trimmed))
			.optional()
			.catch(undefined),
	)
	.transform(filter(isPresent))
	.catch([]);

export type DashboardMetricsMatchers = z.infer<typeof dashboardMetricsMatchers>;
